import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=355b834d&scoped=true"
import script from "./showDetail.vue?vue&type=script&lang=js"
export * from "./showDetail.vue?vue&type=script&lang=js"
import style0 from "./showDetail.vue?vue&type=style&index=0&id=355b834d&lang=css"
import style1 from "./showDetail.vue?vue&type=style&index=1&id=355b834d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b834d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355b834d')) {
      api.createRecord('355b834d', component.options)
    } else {
      api.reload('355b834d', component.options)
    }
    module.hot.accept("./showDetail.vue?vue&type=template&id=355b834d&scoped=true", function () {
      api.rerender('355b834d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeOrderManagement/component/showDetail.vue"
export default component.exports